import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { ReportfilterComponent } from '../../grid/reportfilter/reportfilter.component';

@Component({
  selector: 'app-headcountreport',
  templateUrl: './headcountreport.component.html',
  styleUrls: ['./headcountreport.component.css']
})
export class HeadcountreportComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "HeadCountReport";

  fromdate: any = new Date();
  todate: any = new Date();

  approvalform: string = "";
  filterstatus: string = "ALL";
  filterempid: any = null;
  filterempname: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filtergroupby: string = "BRANCH";

  headcountColl: any = [];
  empColl: any = [];
  
   

  searchtxt: any = "";


  columnDefs = [
    { headerName: 'Form', field: 'trxtype' },
    { headerName: 'Employee', field: 'empname' },
    {
        headerName: 'Date', field: 'transdt', type:'date'    
    },
    { headerName: 'Remarks', field: 'typename' },
    { headerName: 'Desc', field: 'descr' },
    { headerName: 'Status', field: 'approvedstatus' },
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 


  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filterempid = params.empid
      }
      if (params.empname !== undefined) {
        this.filterempname = params.empname
      }

    
      if (params.fromdate !== undefined) {
        console.log(params.fromdate)
        console.log(this.fnConvertDatetime(params.fromdate))
        console.log(this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate)))
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        console.log(params.todate)
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }
  //User Check
  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetHeadCountReport()
   
    this.fngetEmp();
  }


  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {
   
  }

  ngOnDestroy(): void {
 
  }
  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'payadvlist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
    
  }


  fnActionRefreshClick() {
    this.fngetHeadCountReport()
  //  this.fngetEmp();
  }

  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetHeadCountReport();

  }
  fnActionFilterClick() {  

    // this.filterbar.filterstatus = this.filterstatus;
    
    // this.isfilter = !this.isfilter;
    this. fnShowFilterPopup()
  }
  fnApplyFilterPop(data) {
    // this.isfilter = !this.isfilter;

    this.filterstatus = data;
    this.filterempid = data.empid;
    this.filterempname = data.empname;
   

    this.fngetHeadCountReport();

  }


  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    if (this.filterempid > 0) {
      queryParams['empid'] = this.filterempid;
    }
    if (this.filterempname != '') {
      queryParams['empname'] = this.filterempname;
    }
    if (this.filterfromdate != '') {
      queryParams['fromdate'] = this.fnFormatDatetime(this.filterfromdate);
    }
    if (this.filtertodate != '') {
      queryParams['todate'] = this.fnFormatDatetime(this.filtertodate);
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetHeadCountReport();
    }
    else {
      this.filterstatus = "";
      this.fngetHeadCountReport();
    }
  }  
 

   //Get
   fngetEmp() {
    var data = {
      'empid': this.filterempid,
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
         
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
 

  fngetHeadCountReport() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
    
      'empid': this.filterempid,
      'groupby': this.filtergroupby,
      'companyid': this.loginService.fnGetCompanyId(),   

    }
    this.appService.getHeadCountReport(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.headcountColl = res.json().result;

            this.columnDefs = this.generateColumns(this.headcountColl);
            this.gridOptions={
              enableactioncol: false,
              columnDefs:  this.columnDefs
            }
            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  generateColumns(data: any[]) {
    let columnDefinitions = [];

    data.map(object => {

      Object
        .keys(object)
        .map(key => {

          let mappedColumn = {
            headerName: key,
            field: key,
            type:key.toUpperCase() == 'DATE' ? 'date' : '',
            pinned: key.toUpperCase() == 'EMPLOYEE' || key.toUpperCase() == 'CODE' ? 'left' : key.toUpperCase() == 'TOTAL SALARY' ? 'right' : '',
            width: key.toUpperCase() == 'EMPLOYEE' ? 260 : 150,
            minWidth: 150,
            valueFormatter: key.toUpperCase() != 'EMPLOYEE' && key.toUpperCase() != 'PAID DAYS' && key.toUpperCase() != 'CODE' ? '' : ''
          }

          if (key != 'empid') {
            columnDefinitions.push(mappedColumn);
          }

        })
    })
    //Remove duplicate columns
    columnDefinitions = columnDefinitions.filter((column, index, self) =>
      index === self.findIndex((colAtIndex) => (
        colAtIndex.field === column.field
      ))
    )
    return columnDefinitions;
  }

  private fnSetDataTable() {
  
  }

  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(ReportfilterComponent, { size: <any>'xl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.empid = Number(this.filterempid);
    modalRef.componentInstance.filtergroupby = this.filtergroupby;


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)

      if (receivedEntry.status === 'DONE') {
        this.filterempid = receivedEntry.empid;
        this.filterempname = receivedEntry.empname;
        this.filtergroupby = receivedEntry.filtergroupby;
        this.fngetHeadCountReport();
      }


    });
  }
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.headcountColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }
  fnGetDescription(id) {
    const index = this.headcountColl.findIndex(sku => sku.headcountColl === id);

    if (index) {
      return this.headcountColl[index].taxgroupname;
    }
    else {
      return "";
    }

  }
  public fnSearchDatatable(value) {

   

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),   
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//hh:mm a  
    }
    else {
      return '';
    }
  }

  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }
  }
  fnCloseForm(){
    try{
      this.router.navigate(['/Reports']);
    }catch(ex){
       this.fnShowErrorMsg(ex);
    }
    }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
